import { Component, OnInit, ViewChild, inject } from '@angular/core';
import {GameService} from "../../services/game.service";
import {LoadingService} from "../../services/loading.service";
import {MatBottomSheetRef} from "@angular/material/bottom-sheet";
import {GamePlay} from "../../model/game-play";
import {ODK} from "../../model/odk";
import {Down} from "../../model/down";
import { changeHashEvent, SelectHashComponent } from "../select-hash/select-hash.component";
import {DEFAULT_FIRST_DOWN_DISTANCE} from "../../helpers/distance";
import {SelectYardLineComponent} from "../select-yard-line/select-yard-line.component";
import {Hash} from "../../model/hash";
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { SousTitreBlocComponent } from '../sous-titre-bloc/sous-titre-bloc.component';
import { ButtonToggleGroupComponent } from '../button-toggle-group/button-toggle-group.component';
import { MatButtonToggleGroup, MatButtonToggle } from '@angular/material/button-toggle';
import { NgClass } from '@angular/common';
import { BlocWheelComponent } from '../bloc-wheel/bloc-wheel.component';
import { TranslocoModule } from '@ngneat/transloco';

const DEFAULT_RESUME_YARD_LINE = '55';
const DEFAULT_OVERTIME_YARD_LINE = '35'

@Component({
    selector: 'app-dialog-resume-game',
    templateUrl: './dialog-resume-game.component.html',
    styleUrls: ['./dialog-resume-game.component.scss'],
    imports: [MatIconButton, MatIcon, SousTitreBlocComponent, ButtonToggleGroupComponent, MatButtonToggleGroup, MatButtonToggle, NgClass, SelectHashComponent, BlocWheelComponent, SelectYardLineComponent, TranslocoModule]
})
export class DialogResumeGameComponent implements OnInit {
  game = inject(GameService);
  loadingService = inject(LoadingService);
  private _bottomSheetRef = inject<MatBottomSheetRef<DialogResumeGameComponent>>(MatBottomSheetRef);

  protected readonly Down = Down;
  protected readonly ODK = ODK;
  gamePlay:GamePlay = this.game.getFirstPendingGamePlay();
  qtr = 1;
  hash:Hash = Hash.L;
  down:Down = Down.D1;
  odk:ODK = ODK.Offensive;
  distanceToGo  = DEFAULT_FIRST_DOWN_DISTANCE
  yardLine = DEFAULT_RESUME_YARD_LINE

  @ViewChild('distanceToGoSelector') distanceToGoSelector!: SelectYardLineComponent;
  @ViewChild('spotTheBallSelector') spotTheBallSelector!: SelectYardLineComponent;

  constructor() {
    this.gamePlay = this.game.getFirstPendingGamePlay();
  }

  ngOnInit() {
    if (this.game?.game === undefined) {
      this.game.reloadGame()
    }
    this.init();
  }

  public init() {
    this.odk = this.gamePlay.odk
    this.qtr = this.gamePlay.qtr
    this.hash = this.gamePlay.hash
    this.down = this.gamePlay.down === Down.D0 ? Down.D1 : this.gamePlay.down
    this.distanceToGo = this.gamePlay.distance || DEFAULT_FIRST_DOWN_DISTANCE
    if (this.game.isGameInOvertime()) {
      this.gamePlay.yardLine = this.gamePlay.yardLine || DEFAULT_OVERTIME_YARD_LINE
    } else {
      this.gamePlay.yardLine = this.gamePlay.yardLine || DEFAULT_RESUME_YARD_LINE
    }
    this.yardLine = this.gamePlay.yardLine
  }

  getLastQuarter(): number {
    return this.gamePlay.qtr
  }

  getLastHash() {
    return this.gamePlay.hash
  }

  getLastDistance(): string {
    const distance = this.gamePlay.distance || DEFAULT_FIRST_DOWN_DISTANCE;
    return distance.toString()
  }

  getLastYardLine(): string {
    return this.gamePlay.yardLine
  }

  close() {
    this._bottomSheetRef.dismiss();
  }

  setHome(){
    this.odk = ODK.Offensive;
  }
  setAway(){
    this.odk = ODK.Defensive;
  }
  setQuarter(quarter:number){
    this.qtr = quarter;
    if (this.qtr === 5) {
      this.gamePlay.yardLine = DEFAULT_OVERTIME_YARD_LINE
      this.yardLine = this.gamePlay.yardLine
    }
  }

  setDown(down:Down) {
    this.down = down;
  }

  onChangeHash($event: changeHashEvent) {
    this.hash = $event.hash;
  }

  onDistanceChange(distance: string) {
    this.distanceToGo = parseInt(distance)
  }

  onSpotBallChange(spot: string) {
    this.yardLine = spot;
  }

  saveGamePlay() {
    this.gamePlay.odk = this.odk
    this.gamePlay.qtr = this.qtr
    this.gamePlay.hash = this.hash
    this.gamePlay.down = this.down
    this.gamePlay.distance = this.distanceToGo
    this.gamePlay.yardLine = this.yardLine
    this.close()
  }
}
